import * as Sentry from '@sentry/browser';
import { initLoc as initLocalization } from '../../../packages/src/localization/index.js';
import {
  getEventLanguageSettings,
  normalizeLanguageSettings,
  resolveLanguageCode,
} from '../../../packages/src/localization/languageSettings.js';

export { t } from '../../../packages/src/localization/index.js';

const LOC_PARAMS_KEY = 'locParams';

export async function initLoc(params) {
  const storedLocParams = getLocParams();
  const safeParams = params && typeof params === 'object' ? params : undefined;
  const locParams = safeParams || storedLocParams;
  const languageSettings = normalizeLanguageSettings(locParams.languageSettings);
  const initialLanguage = resolveInitialLanguage(languageSettings);

  setLocParams({
    ...locParams,
    languageSettings,
  });

  await initLocalization({
    orgId: locParams.orgId,
    eventCode: locParams.eventCode,
    projectName: 'webapp',
    languageSettings,
    initialLanguage,
  });
}

export async function initEventLoc(event) {
  await initLoc(createEventLocParams(event));
}

export function getLocalizationContext() {
  return getLocParams();
}

export function storeEventLocContext(event) {
  setLocParams(createEventLocParams(event));
}

export function getCurrentLanguageSettings() {
  return normalizeLanguageSettings(getLocParams().languageSettings);
}

export function setTextToElement(cssPath, text) {
  const element = document.querySelector(cssPath);
  if (element) {
    element.textContent = text;
  } else {
    const error = new Error(`Element not found for CSS path: ${cssPath}`);
    console.error(error);
    Sentry.captureException(error);
  }
}

function createEventLocParams(event) {
  return {
    orgId: event.organisation?.id,
    eventCode: event.name,
    languageSettings: getEventLanguageSettings(event.opts),
  };
}

function setLocParams(locParams = {}) {
  if (typeof sessionStorage === 'undefined' || !locParams.orgId || !locParams.eventCode) {
    return;
  }
  sessionStorage.setItem(LOC_PARAMS_KEY, JSON.stringify(locParams || {}));
}

function getLocParams() {
  if (typeof sessionStorage === 'undefined') {
    return {};
  }
  return JSON.parse(sessionStorage.getItem(LOC_PARAMS_KEY) || '{}');
}

function resolveInitialLanguage(languageSettings) {
  const allowedLanguages = new Set(languageSettings.availableLanguages);
  const storedLanguage = resolveLanguageCode(localStorage.getItem('i18nextLng'));

  if (allowedLanguages.has(storedLanguage)) {
    return storedLanguage;
  }

  const browserLanguage = resolveLanguageCode(globalThis.navigator?.language);
  if (allowedLanguages.has(browserLanguage)) {
    return browserLanguage;
  }

  return languageSettings.defaultLanguage;
}
